// extracted by mini-css-extract-plugin
export default {"settingsResetButtonWrapper":"ButtonResetSettings_settingsResetButtonWrapper__yK8jg","settingsResetButton":"ButtonResetSettings_settingsResetButton__ksIyx"};